<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        inline
        :model="searchForm"
        :label-width="$device.tablet ? '' : '80px'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <!--            <el-row>-->
        <!--                <el-col :span="6">-->
        <!--                    <el-form-item :label="$t('대행 업체 이름')">-->
        <!--                        <el-input v-model="searchForm.brandName" @keyup.enter.native="search"-->
        <!--                                  clearable></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </el-col>-->
        <!--            </el-row>-->
        <el-row>
          <el-col>
            <el-form-item :label="$t('기간')">
              <el-date-picker
                v-model="sedtm"
                type="datetimerange"
                clearable
                unlink-panels
                @change="searchFirstPage"
                :style="{ width: `auto` }"
                :default-time="['06:00:00', '23:00:00']"
                :start-placeholder="$t('날자 선택')"
                :end-placeholder="$t('날자 선택')"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('OrderDeliveryForStoreSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 한 장만 받는 목록에서 `sortable` 은 「이 페이지 안에서만」이라
           사람이 본 순서와 서버가 고른 50건이 서로 다른 말을 한다. 열 이름이 곧 서버의 정렬 축이라 별칭은 없다 -->
      <el-table-column
        :label="$t('ID')"
        prop="id"
        min-width="70"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('주문코드')"
        prop="orderCd"
        min-width="80"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('주문번호')"
        prop="orderNo"
        min-width="80"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('대행 업체 이름')"
        prop="brandName"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('라이더 이름')"
        prop="riderName"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('라이더 연락처')"
        prop="riderTel"
        :formatter="util.telCell"
        min-width="100"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('상태')"
        prop="status"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('주문 발생 시간')"
        prop="orderDateTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('기사 호출 시간')"
        prop="requestedDateTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('예상 픽업 시간')"
        prop="expectedPickupTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('라이더 배차 시간')"
        prop="allocatedDateTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('라이더 픽업 시간')"
        prop="pickupDateTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('배달 완료 시간')"
        prop="completeDateTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('배달 취소 시간')"
        prop="canceledDateTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('마지막 상태 변경 시간')"
        prop="lastUpdatedDateTime"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { withPaging } from '@/utils/pagedList'

export default {
  mixins: [mainVueMixin, pagedListMixin],

  data: function () {
    var data = initData()
    data.url = '/order-delivery/store'
    data.storeLans = []
    data.activiTab = ''

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.sedtm = [
      util.getDate('yyyy-MM-dd HH:mm:ss', util.dateAdd('h ', -1, new Date())),
      util.getDate('yyyy-MM-dd HH:mm:ss', new Date()),
    ]
    data.orderDeliveryStatus = []
    data.orderDeliveryStatusNames = []

    data.dictionaryDialogFormVisible = false

    data.closeDialogVisible = false

    return data
  },
  created: function () {
    this.initStore()
    // 첫 조회도 게이트를 지난다 — 기본 기간이 늘 서 있지만, 전제 판정의 자리를 한 곳으로 둔다
    this.searchFirstPage()
  },

  watch: {
    formError: {
      deep: true,
      handler: function (newVal, oldVal) {},
    },
  },
  methods: {
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다
    // (기본 50건·첫 페이지·서버 기본 정렬 `requestedDateTime DESC, id DESC`)
    initSearchForm: function () {
      return withPaging({
        brandName: '',
        startDate: '',
        endDate: '',
        orderDeliveryStatus: '',
      })
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        categoryCd: 0,
        categoryNm: '',
        categoryInfos: [],
        ord: 0,
        useYn: 'Y',
        categoryDesc: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        categoryNm: '',
        ord: '',
        useYn: '',
        categoryDesc: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].categoryCd
      }
    },
    initStore: function () {
      this.mainVue.$axios.search(
        '/store/getStore',
        null,
        function (result) {
          this.storeLans = result.lans
          this.initStoreLans(result)
        }.bind(this)
      )
    },
    // 사전 조회를 위한 언어 정보 설정
    initStoreLans: function (store) {
      this.lans = []
      this.lans.push(store.defaultLan)

      for (var i = 0, len = store.lans.length; i < len; i++) {
        this.lans.push(store.lans[i])
      }
    },
    /**
     * 이 조회의 **전제** — 기간이 골라져 있는가. 없으면 왜 막혔는지 말하고 거짓이다.
     *
     * 믹스인의 네 진입점이 **상태를 쓰기 전에** 이것을 묻는다(`pagedListMixin.canSearch`). 종전에는
     * 판정이 `search()` 첫 줄에 있어서, 2페이지를 눌러 페이저·행 번호가 이미 옮겨 앉은 **뒤에**
     * 되돌아갔다 — 요청은 안 나가는데 화면은 2페이지라고 말하는 상태가 된다.
     */
    canSearch: function () {
      if (null == this.sedtm || this.sedtm.length < 2) {
        this.mainVue.$message({ type: 'success', message: this.$t('기간을 선택 하여 주십시오.') })

        return false
      }

      return true
    },
    /**
     * 조회 — **전제는 이미 확인됐다**(믹스인 게이트). 현재 페이지·정렬을 유지한다.
     *
     * 조건이 바뀐 조회(검색 버튼·기간 변경)는 `searchFirstPage` 다.
     */
    search: function () {
      this.searchForm.startDate = this.sedtm[0]

      if (this.searchForm.autoEdtm) {
        this.sedtm = [this.sedtm[0], util.getDate('yyyy-MM-dd HH:mm:ss', new Date())]
      }

      this.searchForm.endDate = this.sedtm[1]

      // this.searchForm.orderDeliveryStatusNames = ['CALL_REQUEST', 'RECEIPT', 'CANCELED', 'RIDER_ALLOCATE', 'RIDER_PICKUP', 'COMPLETE'];
      // this.searchForm.orderDeliveryStatus = ['배달 요청', '접수 완료', '요청 취소', '배차 완료', '픽업 완료', '배달 완료'];

      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('카테고리 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      for (var i = 0, len = this.inputForm.categoryInfos.length; i < len; i++) {
        this.formError['categoryInfos[' + i + '].categoryInfoNm'] = ''
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.categoryCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 키워드 데이타 선택
    selectDictionary: function (row) {
      for (var i = 0, len = this.lans.length; i < len; i++) {
        // 기본 언어 새팅
        if (0 == i) {
          this.inputForm.categoryNm = row[this.lans[i].id]
        } else {
          // 타언어 순서대로 등록
          this.inputForm.categoryInfos[i - 1].categoryInfoNm = row[this.lans[i].id]
        }
      }

      this.dictionaryDialogFormVisible = false
    },
    // 순서 수정
    handleChangeOrd: function (row) {
      this.mainVue.$axios.patchNonLoading(this.url + '/' + row.categoryCd + '/' + row.ord)
    },
  },
}
</script>
